class AnanasCollection extends HTMLElement {
  connectedCallback() {
    this.galleries = [...this.querySelectorAll('[data-product-gallery]')];
    this.sortSelect = this.querySelector('[data-collection-sort]');

    this.galleries.forEach((gallery) => this.enableProductGallery(gallery));
    this.sortSelect?.addEventListener('change', this.sortCollection);
  }

  disconnectedCallback() {
    this.galleryCleanups?.forEach((cleanup) => cleanup());
    this.sortSelect?.removeEventListener('change', this.sortCollection);
  }

  sortCollection = (event) => {
    const select = event.currentTarget;
    if (!(select instanceof HTMLSelectElement)) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  };

  enableProductGallery(gallery) {
    if (!(gallery instanceof HTMLElement)) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    const frames = [...gallery.querySelectorAll('[data-product-frame]')];
    if (frames.length <= 1) return;

    this.galleryCleanups = this.galleryCleanups || [];

    const setActiveFrame = (index) => {
      frames.forEach((frame, frameIndex) => {
        frame.toggleAttribute('data-active', frameIndex === index);
      });
    };

    const move = (event) => {
      const rect = gallery.getBoundingClientRect();
      const position = Math.min(Math.max(event.clientX - rect.left, 0), rect.width);
      const index = Math.min(frames.length - 1, Math.floor((position / rect.width) * frames.length));
      setActiveFrame(index);
    };

    const leave = () => setActiveFrame(0);

    gallery.addEventListener('pointermove', move);
    gallery.addEventListener('pointerleave', leave);
    this.galleryCleanups.push(() => {
      gallery.removeEventListener('pointermove', move);
      gallery.removeEventListener('pointerleave', leave);
    });
  }
}

if (!customElements.get('ananas-collection')) {
  customElements.define('ananas-collection', AnanasCollection);
}
